if (!customElements.get('size-guide-tabs')) {
  class SizeGuideTabs extends HTMLElement {
    static get observedAttributes() {
      return ['selected-index'];
    }

    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.size-guide-drawer__tab'));
      this.panels = Array.from(this.querySelectorAll('.size-guide-drawer__panel'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          this.selectedIndex = parseInt(tab.dataset.index, 10);
        });
      });
    }

    get selectedIndex() {
      return parseInt(this.getAttribute('selected-index'), 10) || 0;
    }

    set selectedIndex(index) {
      this.setAttribute('selected-index', index);
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name !== 'selected-index' || oldValue === null || oldValue === newValue) return;

      const nextIndex = parseInt(newValue, 10);
      const prevIndex = parseInt(oldValue, 10);

      this.tabs[prevIndex]?.classList.remove('active');
      this.tabs[prevIndex]?.setAttribute('aria-selected', 'false');
      this.panels[prevIndex]?.classList.remove('active');

      this.tabs[nextIndex]?.classList.add('active');
      this.tabs[nextIndex]?.setAttribute('aria-selected', 'true');
      this.panels[nextIndex]?.classList.add('active');
    }
  }

  customElements.define('size-guide-tabs', SizeGuideTabs);
}

if (!customElements.get('size-guide-opener')) {
  class SizeGuideOpener extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('button');
      const drawer = document.getElementById('Size-Guide-Drawer');

      if (!button || !drawer) return;

      button.addEventListener('click', (event) => {
        event.preventDefault();
        OverlayManager.open(drawer);
      });
    }
  }

  customElements.define('size-guide-opener', SizeGuideOpener);
}
